"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hardGet = hardGet;
exports.mapIncrement = mapIncrement;
exports.assigningGet = assigningGet;
/**
 * Returns a value from a map, or throws an error if not found.
 * @param map the map to fetch from
 * @param key a key to look up
 * @returns the value assoicated with `key` in `map`.
 */
function hardGet(map, key) {
    const ret = map.get(key);
    if (ret === undefined) {
        throw new Error(`Could not find <${key}> in the given map`);
    }
    return ret;
}
/**
 * Increment the value associated with `key` in `map` by `inc`.
 * @param map a map to increment one of its values
 * @param key the key to increment
 * @param inc the amount to increment by
 * @returns the incremented value
 */
function mapIncrement(map, key, inc) {
    const ret = assigningGet(map, key, () => 0) + inc;
    map.set(key, ret);
    return ret;
}
/**
 * Returns the value with `key` in `map`. If not found, set it to the value returned by the given supplier function
 * and returns it.
 * @param map a map to get a value from
 * @param key the key to get
 * @param supplier a zero-arguments callback to provide a value if `key` is not found in `map`
 * @returns the value associated with `key` in `map`
 */
function assigningGet(map, key, supplier) {
    let v = map.get(key);
    if (v === undefined) {
        v = supplier();
        map.set(key, v);
    }
    return v;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYXBzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBV0EsMEJBTUM7QUFTRCxvQ0FJQztBQVVELG9DQU9DO0FBMUNEOzs7OztHQUtHO0FBQ0gsU0FBZ0IsT0FBTyxDQUFPLEdBQWtCLEVBQUUsR0FBTTtJQUN0RCxNQUFNLEdBQUcsR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ3hCLElBQUksR0FBRyxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ3RCLE1BQU0sSUFBSSxLQUFLLENBQUMsbUJBQW1CLEdBQUcsb0JBQW9CLENBQUMsQ0FBQTtJQUM3RCxDQUFDO0lBQ0QsT0FBTyxHQUFHLENBQUE7QUFDWixDQUFDO0FBRUQ7Ozs7OztHQU1HO0FBQ0gsU0FBZ0IsWUFBWSxDQUFJLEdBQXVCLEVBQUUsR0FBTSxFQUFFLEdBQVc7SUFDMUUsTUFBTSxHQUFHLEdBQUcsWUFBWSxDQUFDLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFBO0lBQ2pELEdBQUcsQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFBO0lBQ2pCLE9BQU8sR0FBRyxDQUFBO0FBQ1osQ0FBQztBQUVEOzs7Ozs7O0dBT0c7QUFDSCxTQUFnQixZQUFZLENBQU8sR0FBa0IsRUFBRSxHQUFNLEVBQUUsUUFBaUI7SUFDOUUsSUFBSSxDQUFDLEdBQUcsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNwQixJQUFJLENBQUMsS0FBSyxTQUFTLEVBQUUsQ0FBQztRQUNwQixDQUFDLEdBQUcsUUFBUSxFQUFFLENBQUE7UUFDZCxHQUFHLENBQUMsR0FBRyxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQTtJQUNqQixDQUFDO0lBQ0QsT0FBTyxDQUFDLENBQUE7QUFDVixDQUFDIn0=